import axios from 'axios'
import _ from 'lodash'
var Article = {};
var _baseURL = process.env.VUE_APP_AUTH_API + '/articles';

const uploadImage = function uploadImage(data) {
  return axios({
    method: 'POST',
    url: `${_baseURL}/upload_image`,
    data: { data },
    withCredentials: true,
  })
}

Article.install = function(Vue) {
  Vue.prototype.$article = {
    fetchArticles(params, callback) {
      axios({
        method: 'GET',
        url: _baseURL,
        params,
        withCredentials: true,
      }).then(
        callback,
      )
    },
    createArticle(params, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL,
        data: { article: params },
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
    updateArticle(params, callback, errorCallback) {
      axios({
        method: 'PATCH',
        url: `${_baseURL}/${params.id}`,
        data: { article: params },
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
    updateArticleOrder(data, callback, errorCallback) {
      axios({
        method: 'PATCH',
        url: `${_baseURL}/update_order`,
        data,
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
    destroyArticle(id, callback, errorCallback) {
      axios({
        method: 'DELETE',
        url: `${_baseURL}/${id}`,
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
    shouldHaveProductionPublishLink() {
      return !_.isNil(process.env.VUE_APP_PRODUCTION_AUTH_API);
    },
    publishToProduction(params, callback, errorCallback) {
      axios({
        method: 'POST',
        url: process.env.VUE_APP_PRODUCTION_AUTH_API + '/articles',
        data: { article: params },
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
    uploadImage
  }
}

export { Article as default, uploadImage };
